var React = require('react');

function ParkingCircleSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M168,352V234.61L257.78,304H232v48a16,16,0,0,1-16,16H184A16,16,0,0,1,168,352ZM360,224a80,80,0,0,0-80-80H184a16,16,0,0,0-15,10.49L238.22,208H280a16,16,0,0,1,0,32h-.38l54.95,42.47A79.75,79.75,0,0,0,360,224Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8Zm0,432C146.54,440,64,357.46,64,256a182.66,182.66,0,0,1,21.17-85.41L371.56,391.94A183.06,183.06,0,0,1,248,440Zm162.83-98.59L124.44,120.06A183.06,183.06,0,0,1,248,72c101.46,0,184,82.54,184,184a182.66,182.66,0,0,1-21.17,85.41Z","className":"fa-primary","key":2})]);
}

ParkingCircleSlash.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = ParkingCircleSlash;

ParkingCircleSlash.default = ParkingCircleSlash;
